import React, {useContext, useEffect, useState} from "react";
import {Button, Form} from "react-bootstrap";
import FeatherIcon from "feather-icons-react";
import {Link} from "react-router-dom";
import AuthContext from "../contexts/AuthContext";
import {useTranslation} from "react-i18next";
import MiniLoader from "./MiniLoader";
import GoogleAuth from "./GoogleAuth";
import FacebookAuth from "./FacebookAuth";

const LoginForm = ({ onClose }) => {
    const { t } = useTranslation();
    let {loginUser, loader, user} = useContext(AuthContext)

    const [passwordShown, setPasswordShown] = useState(false);
    const togglePassword = () => {setPasswordShown(!passwordShown);};

    useEffect(() => {
        if (user && onClose) onClose();
    }, [user, onClose]);

    return (
        <>
            <center>
                <h2 style={{marginBottom: "-5px"}}>{t('Login')}</h2>
            </center>
            { !loader ? (
                <>
                    <div className="social-media">
                        <GoogleAuth />
                        <FacebookAuth />
                    </div>

                    <div className="auth-divider">{t("OR")}</div>

                    <Form onSubmit={loginUser}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>{t('Email address')}</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder={t("Enter email")}
                                name="email"
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3 password" controlId="formBasicPassword">
                            <Form.Label>{t("Password")}</Form.Label>
                            <Link to="/verify-email" onClick={onClose}>
                                {t("Forgot")}
                            </Link>
                            <Form.Control
                                required
                                type={passwordShown ? "text" : "password"}
                                name="password"
                                autoComplete="on"
                                placeholder={t("Enter password")}
                            />
                            <FeatherIcon icon={passwordShown ? "eye" : "eye-off"} onClick={togglePassword} />
                        </Form.Group>
                        <Button
                            variant="green"
                            type="submit"
                        >
                            {t("Sign In")}
                        </Button>
                    </Form>

                    <div className="auth-footer">
                        <span style={{ marginRight: '5px' }}>{t('Account yet')}</span>
                        <Link to="/sign-up" onClick={onClose}>{t('Sign up')}</Link>
                    </div>
                </>
            ) : (
                <div className="center-block">
                    <center>
                        <MiniLoader />
                    </center>
                </div>
            )}
        </>
    )
}

export default LoginForm
